import React from 'react';
import Parser from 'react-html-parser';
import styles from './styles';
import baseStaticStyles from '../BaseStaticPage/styles';
import { withResizer } from '../../../HoCs';
import { EVENT_CATEGORIES } from '../../../services/Analytics';
import BaseStaticPage from '../BaseStaticPage';
import { isEmptyList, merge } from '../../../utils';
import CaseStudy from './components/CaseStudy';
import VideoCard from '../../../ui-components/VideoCard';

class CaseStudies extends BaseStaticPage {

    styles = merge(baseStaticStyles, styles);
    content_json_key = 'case_studies_content_json';
    pageEventCategory = EVENT_CATEGORIES.CASE_STUDIES_PAGE;

    state = this.parseJsonString();

    renderImageContent = () => {
        const { image_heading, image_content } = this.state.data;
        return <div style={merge(this.gs('right_card'), this.gs('right_card_override'))}>
            <div style={this.gs('image_heading')}>{Parser(image_heading)}</div>
            <div style={this.gs('image_divider')} />
            <div style={this.gs('image_content')}>{Parser(image_content)}</div>
        </div>;
    }

    renderCaseStudies = () => {
        const { case_studies_heading, case_studies } = this.state.data;
        if (isEmptyList(case_studies)) return null;

        return <div style={this.gs('case_studies')}>
            <div style={this.gs('section_heading')}>{Parser(case_studies_heading)}</div>
            {case_studies.map(({ image, image_footing, heading, content, footing, cta_link, cta_text }, i) =>
                <CaseStudy key={i} image={image} image_footing={Parser(image_footing)} heading={Parser(heading)}
                    content={Parser(content)} footing={Parser(footing)} style={this.gs(i % 2 ? 'case_study' : 'case_study_reverse')}
                    cta_link = {cta_link} cta_text = {cta_text} button_style={this.gs('cta_button')}/>
            )}
        </div>;
    };

    renderVideos = () => {
        const { videos_heading, videos } = this.state.data;
        if (isEmptyList(videos)) return null;

        return <>
            <div style={this.gs('section_heading')}>{Parser(videos_heading)}</div>
            <div style={this.gs('videos_container')}>
                {videos.map(({ id, thumbnail, title, description }) =>
                    <VideoCard key={id} youtubeID={id} thumbnail={thumbnail} title={title} description={description} style={{ boxShadow: 'var(--shadow)', width: 'min-content', margin: 16 }} />
                )}
            </div>
            <div style={{ height: 64 }} />
        </>
    }

    renderContent = () => <>
        {this.renderCaseStudies()}
        {this.renderVideos()}
    </>;

}

export default withResizer(CaseStudies);